"use strict";
// Is something missing?
// For when we need yet another value that isn't null or undefined.
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNotMissing = exports.isMissing = exports.missing = void 0;
exports.missing = Symbol();
function isMissing(v) {
    return v === exports.missing;
}
exports.isMissing = isMissing;
function isNotMissing(v) {
    return v !== exports.missing;
}
exports.isNotMissing = isNotMissing;
//# sourceMappingURL=missing.js.map